import { Component, OnInit } from '@angular/core';
import {Observable} from "rxjs";
import {Field} from "../field";
import {DetailService} from "../../../../services/details/detail.service";

@Component({
  selector: 'tig-reload',
  template: ``
})
export class ReloadComponent extends Field implements OnInit {

  OBJ_observable_external_data: Observable<void>;

  constructor(protected OBJ_detail_service: DetailService) {
    super();
  }

  ngOnInit() {
  }

}
